import { useEffect, useState } from 'react';

const getWindowWidth = () => (
  typeof window === 'undefined' ? 1200 : window.innerWidth
);

const getTouchPreference = () => (
  typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(pointer: coarse)').matches
);

/**
 * Hook to detect device type based on screen width
 * @param {number} mobileBreakpoint - Breakpoint width for mobile devices (default: 768px)
 * @returns {object} - Shared responsive flags used across the application
 */
const useResponsive = (mobileBreakpoint = 768) => {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth);
  const [isTouch, setIsTouch] = useState(getTouchPreference);
  const isMobile = windowWidth <= mobileBreakpoint;
  const isSmallMobile = windowWidth <= 480;
  const isTablet = windowWidth > mobileBreakpoint && windowWidth <= 1024;
  const isCompact = windowWidth <= 1024;
  const isDesktop = windowWidth > 1024;
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setIsTouch(getTouchPreference());
    };
  
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isCompact,
    isDesktop,
    isMobile,
    isSmallMobile,
    isTablet,
    isTouch,
    windowWidth,
  };
};

export default useResponsive;
